import { render, staticRenderFns } from "./ModalIndicadorPrimario.vue?vue&type=template&id=b3664596"
import script from "./ModalIndicadorPrimario.vue?vue&type=script&lang=js"
export * from "./ModalIndicadorPrimario.vue?vue&type=script&lang=js"
import style0 from "./ModalIndicadorPrimario.vue?vue&type=style&index=0&id=b3664596&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports